import $ajax from 'axios'

//获取所有建筑物
export function getBuildingList() {
  return $ajax({
    url: '/v1/building/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有作业票
export function getWorkPermitList(username, password) {
  return $ajax({
    url:'/v1/workPermit/list_all',
    method: "POST",
    data: {
    }
  })
}

//获取所有监控
export function getCameraList() {
  return $ajax({
    url: '/v1/licensePlateCamera/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有重大危险源
export function getDangerList() {
  return $ajax({
    url: '/v1/dsMajorHazards/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有作业人员
export function getWorkerList() {
  return $ajax({
    url: '/v1/employee/getAll',
    method: "GET",
    params: {
    },
  })
}

//获取所有车辆
export function getVehicleList() {
  return $ajax({
    url: '/v1/vehicleInformation/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有风险区域
export function getRiskAreaList() {
  return $ajax({
    url: '/v1/riskclassification/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有设备装置
export function getDeviceList() {
  return $ajax({
    url: '/v1/equipment/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有有害物质
export function getHarmList() {
  return $ajax({
    url: '/v1/harmfulmessage/list_all',
    method: "GET",
    params: {
    },
  })
}

//获取所有仓库物资
export function getStoreList() {
  return $ajax({
    url: '/v1/materials/list_all',
    method: "POST",
    data: {
    },
  })
}

//获取所有模型
export function getModelList() {
  return $ajax({
    url: '/v1/model/list_all',
    method: "GET",
    data: {
    },
  })
}
